'use es6';

import { Record } from 'immutable';
export default Record({
  timeUnit: null,
  numberOfTimeUnits: null
}, 'Reminder');